import React from 'react';
import { Star } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    name: 'Chioma O.',
    role: 'Property Buyer',
    image: 'https://i.pinimg.com/1200x/15/2a/7d/152a7de46d09993cf383b8a6cc652d72.jpg',
    content: 'MUNISVerse transformed my property search experience. I was able to tour over 15 properties in Lagos from my home in Abuja, saving me countless hours and travel expenses. The VR experience was incredibly realistic.'
  }, {
    name: 'Seyi A.',
    role: 'Real Estate Developer',
    image: 'https://i.pinimg.com/736x/7e/83/0e/7e830e9c49dee63d546ba2b376523d30.jpg',
    content: "Implementing MUNISVerse's VR solutions for our new development increased our sales velocity by 40%. International investors were particularly impressed with the ability to experience our properties remotely."
  }, {
    name: 'Michael D.',
    role: 'Expatriate Relocating to Nigeria',
    image: 'https://i.pinimg.com/736x/22/5f/4c/225f4c968155fcd81cc89182f673583b.jpg',
    content: 'The relocation process was seamless thanks to MUNISVerse. Being able to virtually tour properties before my move to Lagos gave me confidence in my housing decision. Their team was professional and responsive throughout.'
  }];
  return <section id="testimonials" className="py-24 relative overflow-hidden" data-id="element-380">
      <div className="absolute -top-40 right-20 w-[400px] h-[400px] gradient-circle opacity-20" data-id="element-381"></div>
      <div className="absolute -bottom-40 left-20 w-[400px] h-[400px] gradient-circle opacity-20" data-id="element-382"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-383">
        <div className="max-w-3xl mx-auto text-center mb-16 reveal" data-id="element-384">
          <div className="inline-block bg-glass px-4 py-1 rounded-full text-xs font-medium mb-6 text-[#00d4ff]" data-id="element-385">
            TESTIMONIALS
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-386">
            Client <span className="text-gradient" data-id="element-387">Success</span> Stories
          </h2>
          <p className="text-lg text-gray-300" data-id="element-388">
            Hear from clients who have transformed their real estate experience
            with MUNISVerse.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-389">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-glass rounded-xl p-8 card-hover neon-border reveal" style={{
          animationDelay: `${index * 200}ms`
        }} data-id="element-390">
              <div className="flex items-center mb-6" data-id="element-391">
                <div className="flex-shrink-0 mr-4" data-id="element-392">
                  <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-[rgba(0,212,255,0.3)]" data-id="element-393">
                    <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover" data-id="element-394" />
                  </div>
                </div>
                <div data-id="element-395">
                  <h4 className="text-lg font-semibold" data-id="element-396">{testimonial.name}</h4>
                  <p className="text-sm text-gray-400" data-id="element-397">{testimonial.role}</p>
                </div>
              </div>
              <div className="flex mb-4" data-id="element-398">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} className="text-[#ff0080] fill-current" data-id="element-399" />)}
              </div>
              <p className="text-gray-300 italic" data-id="element-400">"{testimonial.content}"</p>
            </div>)}
        </div>
      </div>
    </section>;
};